import { VALIDATORS } from '@/shared/constants';
import { FormControl, FormGroup, Validators } from '@angular/forms';

export const getWiredConfigForm: FormGroup = new FormGroup({
    connectionMethod: new FormControl(''),
    dns1: new FormControl('', Validators.pattern(VALIDATORS.IP_VALIDATOR)),
    dns2: new FormControl('', Validators.pattern(VALIDATORS.IP_VALIDATOR)),
    dns3: new FormControl('', Validators.pattern(VALIDATORS.IP_VALIDATOR)),
});
